import React from "react";
import { GlobalStyles } from "./GlobalStyles";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { UnbeatableOdds } from "./components/UnbeatableOdds";
import { Features } from "./components/Features";
import { Stats } from "./components/Stats";
import { RetentionTool } from "./components/RetentionTool";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { LanguageSwitcher } from "./components/LanguageSwitcher";
import { HeroVariant } from "./components/HeroVariant";
import HowAIWorks from "./components/HowAIWorks";

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <main>
        <Hero />
        <HeroVariant />
        <HowAIWorks />
        {/* <Features /> */}
        <Stats />
        <RetentionTool />
        <Contact />
      </main>
      <Footer />
      <LanguageSwitcher />
    </>
  );
}

export default App;

